import React from 'react';

// MD3 checkbox row: the native input keeps focus + accessibility semantics,
// while .md3-checkbox-box paints container, state layer and checkmark.
// Styles: app/styles/checkbox.css.
export default function CheckboxRow({ id, label, checked, onChange, disabled = false }) {
  return (
    <label className="md3-checkbox" htmlFor={id}>
      <input
        className="md3-checkbox-input"
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className="md3-checkbox-box" aria-hidden="true" />
      <span className="md3-checkbox-label">{label}</span>
    </label>
  );
}
